module.exports = __webpack_public_path__ + "static/media/michelle_grant.78a2a9a0.jpg";